import * as React from "react";
import type { SVGProps } from "react";
const SvgContinuousPersonalization1 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={66}
    fill="none"
    {...props}
  >
    <path
      fill="#D3ECF8"
      stroke="#26A3DD"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.75}
      d="m42.862 49.057 9.04 14.37a3.37 3.37 0 0 0 4.86.91l2.54-1.88a3.37 3.37 0 0 0 .46-5l-11.58-12.48c-2.78-3-7.5.62-5.32 4.09v-.01Z"
    />
    <path
      stroke="#26A3DD"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.75}
      d="M30.593 48.736c11.31 0 20.48-9.169 20.48-20.48 0-11.31-9.17-20.48-20.48-20.48-11.311 0-20.48 9.17-20.48 20.48 0 11.311 9.169 20.48 20.48 20.48Z"
    />
    <path
      stroke="#26A3DD"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.75}
      d="M37.422 54.647c-4.41 1.14-9.16 1.2-13.88-.06-14.54-3.9-23.17-18.84-19.27-33.38 3.9-14.54 18.84-23.17 33.38-19.27 14.54 3.9 23.17 18.84 19.27 33.38-.33 1.22-.73 2.4-1.21 3.54"
    />
    <path
      fill="#26A3DD"
      stroke="#26A3DD"
      strokeWidth={0.25}
      d="m52.414 35.41-.117.05.05.116 2.45 5.6.053.121.117-.059 5.552-2.791.113-.058-.059-.112-.476-.904-.057-.108-.11.055-4.44 2.234-1.956-4.478-.05-.112-.113.047-.957.4Z"
    />
    <path
      fill="#26A3DD"
      d="M12.14 38.189a.82.82 0 0 1-.505-1.463l11.459-8.97a.816.816 0 0 1 .792-.121l9.282 3.476 6.915-11.686a.82.82 0 0 1 1.063-.319l9.316 4.562-1-1.541a.819.819 0 0 1 1.447.77l.627 2.24a.82.82 0 0 1-1.083.35l-9.347-4.576-6.88 11.626a.822.822 0 0 1-.991.35l-9.496-3.557-11.097 8.687a.814.814 0 0 1-.504.173l.002-.001Z"
    />
    <circle cx={33.183} cy={31.844} r={3.717} fill="#D3ECF8" />
    <circle cx={40.18} cy={19.845} r={3.717} fill="#D3ECF8" />
    <path
      fill="#26A3DD"
      d="M33.182 35.562a3.723 3.723 0 0 1-3.72-3.718 3.723 3.723 0 0 1 3.72-3.718 3.721 3.721 0 0 1 3.718 3.718 3.722 3.722 0 0 1-3.718 3.718Zm0-5.798a2.082 2.082 0 0 0-2.082 2.08 2.081 2.081 0 1 0 2.082-2.08ZM40.18 23.562a3.722 3.722 0 0 1-3.718-3.718 3.722 3.722 0 0 1 3.718-3.718 3.722 3.722 0 0 1 3.718 3.718 3.721 3.721 0 0 1-3.718 3.718Zm0-5.798c-1.147 0-2.08.933-2.08 2.08 0 1.148.933 2.08 2.08 2.08 1.148 0 2.08-.932 2.08-2.08 0-1.147-.932-2.08-2.08-2.08Z"
    />
    <circle cx={23.18} cy={28.845} r={3.717} fill="#D3ECF8" />
    <path
      fill="#26A3DD"
      d="M23.18 32.562a3.722 3.722 0 0 1-3.718-3.718 3.722 3.722 0 0 1 3.718-3.718 3.721 3.721 0 0 1 3.717 3.718 3.721 3.721 0 0 1-3.717 3.718Zm0-5.798c-1.147 0-2.08.933-2.08 2.08 0 1.148.933 2.08 2.08 2.08 1.148 0 2.08-.932 2.08-2.08 0-1.147-.932-2.08-2.08-2.08Z"
    />
  </svg>
);
export default SvgContinuousPersonalization1;
